// Central image registry. Replace these URLs with real photography when it is
// supplied — no image is referenced directly inside a component.
const CDN =
  "https://static.prod-images.emergentagent.com/jobs/cb50eece-dbdd-49d9-9af6-4df95f5ad6a9/images";

export const media = {
  heroLunchbox: `${CDN}/fb35f370a5ecfc330fe137b5c060b2f7d928babd232378eea5767fa77fadc2e9.jpeg`,
  founderAndChild: `${CDN}/07a0bb4c54da091557354d0249ad0db16662e962a301e5121e74cda2424cb6fc.jpeg`,
  deliveryPackaging: `${CDN}/500da69c19c41a9bfc5b39830898d801c1e9729b302a720cf2dd647400c3d10a.jpeg`,
  kitchenPrep: `${CDN}/73de9a817526bb1dc6861c64f243f91994041e4b74245b38271520f44b99b482.jpeg`,
  childEating: `${CDN}/7ab42ad5d61816e1393d14f81331d4b22eab3717454c7520bb813f56cbc6d088.jpeg`,
  ingredients:
    "https://images.unsplash.com/photo-1466637574441-749b8f19452f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  meals: {
    varanBhaat: `${CDN}/63bfaa7390b347040412082f322cdb32085049222b0df8738eae5fecdd140a5e.jpeg`,
    moongSheera: `${CDN}/a03e8b700eb0a11750a2d0392466ff0ff3e8a39734cefc053b57b9c9752313a4.jpeg`,
    theplaAloo: `${CDN}/1941356e1e175a2d565b8febfdf9341b10f7b41febe0cacada0b79359e4c1a49.jpeg`,
    ragiIdli: `${CDN}/e57586c09a3a38df67fa9ada95a48426ecff88d840e89d1a22f020691c06fa9a.jpeg`,
    laukiDal: `${CDN}/cd60c0f45308d766bbd57e19ba136030b7aae8873fedd45f52d28f6b357e8d5e.jpeg`,
    pumpkinMatki: `${CDN}/ea748f760dfcedc4050982b84511b42daf3fe223f17e38ffa015898ed80a134e.jpeg`,
    khichdiKadhi: `${CDN}/eb9859ca9bcae4ce44a455f5c0ad8f404b76ed7b7f01a7d859e740fbac511ba6.jpeg`,
    moongPaneerBhurji: `${CDN}/04efa0b76abf1afaf165686fcf35a99bfeb5915d0316ffb587e7cf10705582e3.jpeg`,
    moringaSambar: `${CDN}/4d9922b36ac8196edb507c954172da78faae0bea6616bbff955fd91396a6811e.jpeg`,
    puranPoli: `${CDN}/89db27dac8439c486a415707bb67347c398c20f7aef94f946570355256292421.jpeg`,
    sukhiMoong: `${CDN}/889c364260b5ec2809ba6f01c70fbec31680cda2496721f7897114cf3ab8b600.jpeg`,
    horseGram: `${CDN}/a0653cde473e60e9cef7576de6dc015d84642c2df59a4c12afae2a3fe3803e31.jpeg`,
    masoorDal: `${CDN}/3905e7c762184458489229d5a5d54ac4bdd026521b5e1c8999a73af08b4f5daa.jpeg`,
    chainsoo: `${CDN}/23cdc866f69b1f226e5d1daefb9c34531a4c6ec28d5dbd4b1587a05da7e4e048.jpeg`,
  },
  breakfast: {
    raab: `${CDN}/699901c203f23ff544b7dc6cba5af9f3f1eb2f005007b7068e14821e68b66c76.jpeg`,
    bajraKadha: `${CDN}/dfb7aff8a909dd127fb0678bd71aefbe8fc1721582569a8134663cd27996cd47.jpeg`,
    saffronAlmond: `${CDN}/5e1342fbbf7d1045dc696db0575d19a4d3f7976cb6787881892fb00a9b549626.jpeg`,
    brainOats: `${CDN}/9c2e0802ea181a87774cb18c4f3e67054343c6862f2630e5a39303a271782e34.jpeg`,
    rajgiraBowl: `${CDN}/3d444555d8bbb4863322b1a471a63b40eb16e12329960c15b74619c9c197130e.jpeg`,
    warriorAmaranth: `${CDN}/ad2b57057fb509f5e8aee0cf28a85d57716c3d8c3dbd483d987c9ea97bec5d87.jpeg`,
    bananaPancakes: `${CDN}/e8b7f74c77f375455e78194d1f32e6847ef4c2f99d1b721cf123038c96a8cc44.jpeg`,
    chiaWrap: `${CDN}/1892ebfdd0c05108de409abad06838f8b86ed590f79090e845d9bbc9e1763442.jpeg`,
    spinachEggs: `${CDN}/a8388793af9d257e1ce0dc0a9bed4ff0de30267b4acd4c259992b39e8e6c2a31.jpeg`,
    moongChilla: `${CDN}/ed1938b25a08faaed07117ebfa66a176d8b79df54bd602c3155eb0e912553e02.jpeg`,
  },
};

export default media;
